import React, { Component } from "react";
import UserService from "../services/user.service";
import { connect } from "react-redux";
import { Coins } from "../config/clientconfig";
import _ from "lodash";
import axios from "axios";
var ws;
var messageID;
var subscriptions = [];
var pendingMessages;
var subscribeAddressesId = "";

class ContentHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Balance: [],
            USDPrice: 0,
        };
    }

    async componentWillMount() {
        var filterData = await Coins.filter((item) => item.Ticker.includes(this.props.coin));
        if (filterData);
        {
            let api = filterData[0].priceapi.replace("usd", this.props.fiat_currency);
            var pricedata = await axios.get(api);
            if (pricedata.data.length == 1) {
                this.setState({
                    USDPrice: pricedata.data[0].current_price,
                });
            } else {
                this.setState({
                    USDPrice: 0,
                });
            }
        }
        UserService.getBalance(this.props.coin).then(
            (response) => {
                if (response.data.code == 100) {
                    this.setState({
                        Balance: response.data,
                    });
                }
            },
            (error) => {
                this.setState({
                    content: (error.response && error.response.data) || error.message || error.toString(),
                });
            }
        );
    }

    async componentDidUpdate(prevProps) {
        if (this.props.fiat_currency != prevProps.fiat_currency) {
            // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
            var filterData = await Coins.filter((item) => item.Ticker.includes(this.props.coin));
            if (filterData);
            {
                let api = filterData[0].priceapi.replace("usd", this.props.fiat_currency);
                var pricedata = await axios.get(api);
                if (pricedata.data.length == 1) {
                    this.setState({
                        USDPrice: pricedata.data[0].current_price,
                    });
                } else {
                    this.setState({
                        USDPrice: 0,
                    });
                }
            }

            UserService.getBalance(this.props.coin).then(
                (response) => {
                    if (response.data.code == 100) {
                        this.setState({
                            Balance: response.data,
                        });
                    }
                },
                (error) => {
                    this.setState({
                        content: (error.response && error.response.data) || error.message || error.toString(),
                    });
                }
            );
        }
    }

    render() {
        return (
            <div className="iq-navbar-header nova-page-hero">
                <div className="container-fluid iq-container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex justify-content-between align-items-center flex-wrap">
                                <div className="nova-page-title">
                                    <span className="nova-eyebrow">Nova web wallet</span>
                                    <h1>{this.props.pagename}</h1>
                                    <p className="nova-page-subtitle">Manage your assets securely from one place.</p>
                                </div>
                                <div className="nova-hero-actions">
                                    <a href="https://www.novaexchange.co.uk/" target="_blank" rel="noopener noreferrer" className="btn nova-hero-action">
                                        Convert to WVSOL
                                    </a>
                                    <span className="nova-balance-pill">
                                        <i aria-hidden="true"></i> {this.state.Balance.ConfirmedBalance ? this.state.Balance.ConfirmedBalance : 0} {this.props.coin.toUpperCase()} (
                                        {(parseFloat(this.state.Balance.ConfirmedBalance) * parseFloat(this.state.USDPrice)).toFixed(4)} {this.props.fiat_currency.toUpperCase()})
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.auth;
    return {
        user,
    };
}
export default connect(mapStateToProps)(ContentHeader);
